import type { AuthorInfo } from '../types/api';

export function authorLabel(author: AuthorInfo | null | undefined): string {
  if (!author) return 'автор не известен';
  const details = [author.team, author.job].filter(Boolean).join(' · ');
  return details ? `${author.login} (${details})` : author.login;
}
